import { FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import { FunctionComponent } from "react";
import UserDetailProps from "./userDetails";

export const BasicDetails: FunctionComponent<UserDetailProps.BasicDetailProps> = ({
  name,
  setName,
  nationality,
  setNationality,
  gender,
  setGender,
  genderList,
  nationalityList,
  dob,
  setDob,
}) => {
  return (
    <div>
      <div id="basicDetails" className="flex flex-col justify-center mt-5 space-y-3">
        <div id="line1" className="space-y-3">
          <span className="px-3 py-2 bg-gray-300 flex flex-col w-[135px] ml-5 font-bold">
            Basic Details *
          </span>
          <TextField
            id="outlined-basic"
            label="Full Name"
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-[400px]"
            required
            disabled
            inputProps={{ pattern: "[a-zA-Z0-9 ]{1,}" }}
          />
        </div>
        <div id="line2" className="flex justify-between space-x-5">
          <TextField
            id="outlined-basic"
            variant="outlined"
            value={dob}
            onChange={(e) => {
              setDob(e.target.value);
            }}
            className="w-[400px]"
            required
            disabled
          />
          <FormControl className="w-[400px]">
            <InputLabel id="demo-simple-select-label">Nationality</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={nationality}
              label="Nationality"
              onChange={(e) => setNationality(e.target.value)}
            >
              {nationalityList.map((element) => (
                <MenuItem key={element} value={element}>
                  {element}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl className="w-[400px]">
            <InputLabel id="demo-simple-select-label">Gender</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={gender}
              label="Gender"
              onChange={(e) => setGender(e.target.value)}
            >
              {genderList.map((element) => (
                <MenuItem key={element} value={element}>
                  {element}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
    </div>
  );
};
